// Packages
import { useTheme } from '@emotion/react';

// MUI
import { Box } from '@mui/material';

export const ChannelTooltips = () => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItem: "center", gap: "6px" }}>
      <Box
        sx={{
          width: "13px",
          height: "13px",
          borderRadius: 1,
          backgroundColor: "#fff",
          border: `1px solid ${theme.palette.primary.main}`,
        }}
      />
      <Box sx={{
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.customFontSize[0],
        color: theme.palette.primary.black,
        fontWeight: theme.typography.customFontWeight[0],
        lineHeight: 1.1
      }}>
        Unselected
      </Box>
      <Box
        sx={{
          width: "13px",
          height: "13px",
          borderRadius: 1,
          backgroundColor: theme.palette.primary.main,
          border: `1px solid ${theme.palette.primary.main}`,
          ml: "10px"
        }}
      />
      <Box sx={{
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.customFontSize[0],
        color: theme.palette.primary.black,
        fontWeight: theme.typography.customFontWeight[0],
        lineHeight: 1.1
      }}>
        Selected
      </Box>
    </Box>
  )
}